import { Component } from '@angular/core';

@Component({
    selector: 'app-company-navigation',
    templateUrl: './company-navigation.component.html',
    styleUrls: [],
    standalone: false
})
export class CompanyNavigationComponent {
  constructor() {}
}
